export default {
  partners: []
}
